module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_0.4c526ce3.png";